import React, {Component} from 'react';
import {Col, Grid, Row} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import KlienciService from "../KlienciService";
import EBOKWatekTresc from "./componentsWatek/EBOKWatekTresc";
import EBOKWatekKlient from "./componentsWatek/EBOKWatekKlient";
import Validator from "../../../utilities/Validator";
import EBOKService from "./EBOKService";
import {TopAlertInformacja, TopAlertUwaga} from "../../../componentsTopsa/alerty/TopAlerts";
import {TopButtonAction} from "../../../componentsTopsa/buttons/TopButtons";
import ReactNotify from "react-notify";
import BiletKodZParagonuContainer from "../../konfiguracja/biletyConfig/biletyJednorazowe/components/bilety_kod_z_paragonu_components/BiletKodZParagonuContainer";
import BiletyService from "../../konfiguracja/biletyConfig/biletyApi/BiletyService";


export default class EBOKWatekContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            klient: null,
            klientJednorazowy: null,
            isLoading: false,
            zgloszenie: null,

            biletZSzukaniaPoKodzieZParagonu: null,
            pokazModal: false,
            setLoader: false,
            errorModal: '',

        };
        this.onClickDodajOdp = this.onClickDodajOdp.bind(this)
        this.onClickZamknijZgloszenie = this.onClickZamknijZgloszenie.bind(this)
        this.onClickWRealizacji = this.onClickWRealizacji.bind(this)
    }

    componentDidMount() {
        this.setState({isLoading: true})
        if (Validator.validateInt(this.props.match.params.zgloszenieId)) {
            this.pobierzZgloszenie(this.props.match.params.zgloszenieId)
        } else {
            this.setState({isLoading: false})
        }
    }

    pobierzZgloszenie(id) {
        EBOKService.pobierzZgloszenie(id).then(function (response) {
            if (response) {
                if (response.data) {
                    this.setState({isLoading: false, zgloszenie: response.data})
                    if ((response.data.idKl !== 1)) {
                        this.pobierzKlienta(response.data.idKl)
                    } else {
                        this.setState({
                            klient: null,
                            klientJednorazowy: {
                                imieNazwisko: response.data.imieKl + ' ' + response.data.nazKl,
                                email: response.data.emailKl,
                            }
                        })
                    }

                } else this.setState({isLoading: false})
            } else this.setState({isLoading: false})
        }.bind(this))
    }

    pobierzKlienta(id) {
        KlienciService.getKlient(id).then(function (response) {
            this.setState({klient: response.data})
        }.bind(this))
    }

    onClickDodajOdp(odp) {
        EBOKService.odpowiedzNaZgloszenie(this.state.zgloszenie.idZgl, odp).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie dodano odpowiedź', "", 3000)
            } else {
                this.refs.notificator.error('Wystąpił błąd podczas dodawania odpowiedzi', "", 3000)
            }
            this.pobierzZgloszenie(this.state.zgloszenie.idZgl)
        }.bind(this))
    }

    onClickWRealizacji() {
        if (window.confirm('Czy na pewno chcesz zmienić status na "W realizacji"?')) {
            EBOKService.realizujZgloszenie(this.state.zgloszenie.idZgl).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie zmieniono status zgłoszenia. Nastąpi przekierowanie do zgłoszeń', "", 3000)
                } else {
                    this.refs.notificator.error('Wystąpił błąd podczas zmiany statusu zgłoszenia', "", 3000)
                }
                setTimeout(function () {
                    this.props.history.push('/zarzadzanie-klientami/ebok')
                }.bind(this), 1500)
            }.bind(this))
        }
    }

    onClickZamknijZgloszenie() {
        if (window.confirm('Czy na pewno chcesz zamknąć to zgłoszenie?')) {
            EBOKService.zamknijZgloszenie(this.state.zgloszenie.idZgl).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie zamknięto zgłoszenie. Nastąpi przekierowanie do zgłoszeń', "", 3000)
                } else {
                    this.refs.notificator.error('Wystąpił błąd podczas zamykania zgłoszenia', "", 3000)
                }
                setTimeout(function () {
                    this.props.history.push('/zarzadzanie-klientami/ebok')
                }.bind(this), 1500)
            }.bind(this))
        }
    }

    onClickWyszukajBilet(nrBiletu) {

        this.setState({errorModal: ''})

        if (nrBiletu.length === 0) {
            alert('Nie uzupełniono numeru z paragonu!')
        } else {
            this.setState({setLoader: true, pokazModal: true})

            BiletyService.szukajBiletuPoKodzieZParagonu("R"+nrBiletu.toString())
                .then(function (response) {
                    console.log(response)
                    this.setState({biletZSzukaniaPoKodzieZParagonu: response.data, setLoader: false})
                }.bind(this))
                .catch(function (err) {
                    this.setState({setLoader: false, errorModal: 'Nie znaleziono takiego kodu'})
                    setTimeout(function () {
                        this.setState({pokazModal: false})
                    }.bind(this), 2000)
                }.bind(this))
        }

    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path}
                              history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'ZgloszenieWatekContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{
                                    addressUrl: '/zarzadzanie-klientami',
                                    text: 'Zarządzanie klientami'
                                }, {addressUrl: '/zarzadzanie-klientami/ebok', text: 'eBOK'},
                                    {
                                        addressUrl: '/zarzadzanie-klientami/ebok/zgloszenie/1',
                                        text: 'Zgłoszenie ' + this.props.match.params.zgloszenieId
                                    }]}/>
                                <SubHeader currentLink={this.props.match.path}
                                           obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                    </Row>
                    {
                        Boolean(this.state.isLoading) ?
                            <div id={'smallLoader'}>
                                <i className={'fa fa-circle-o-notch fa-spin'}></i>
                                <div>Trwa ładowanie zgłoszenia...</div>
                            </div>
                            :
                            Boolean(this.state.zgloszenie) ?
                                <div>
                                <div>
                                    <Row>
                                        <Col xs={12} id={'tytulZgloszenie'}>
                                            <div id={'zgloszenieNumer'}>
                                                <label>Zgłoszenie nr <span
                                                    className={'label label-ebus-primary'}>{this.state.zgloszenie.idZgl}</span></label>
                                                {
                                                    Boolean(this.state.zgloszenie.nrBil) ?
                                                        <span style={{marginLeft: '25px'}}>
                                                            <label>Bilet nr <span
                                                                className={'label label-ebus-default'}>{this.state.zgloszenie.nrBil}</span></label>

                                                            <span style={{marginLeft: '25px'}}>
                                                                <TopButtonAction iconType={'fa fa-search'}
                                                                                 text={'Wyszukaj bilet'}
                                                                                 btnSize={'md'}
                                                                                 onClick={() => this.onClickWyszukajBilet(this.state.zgloszenie.nrBil)}
                                                                                 btnColor={'default'}
                                                                />
                                                            </span>
                                                         </span>
                                                        :
                                                        ''
                                                }
                                                <span style={{marginLeft: '15px'}}>
                                                    {
                                                        (this.state.zgloszenie.status === 0) ?
                                                            <TopButtonAction iconType={'fa fa-gear'}
                                                                             text={'Oznacz jako w realizacji'}
                                                                             btnSize={'md'}
                                                                             onClick={this.onClickWRealizacji}
                                                                             btnColor={'default'}/>
                                                            :
                                                            (this.state.zgloszenie.status === 2 ?
                                                                <span className={'text-info'}
                                                                      style={{fontSize: '14px'}}><i
                                                                    className={'fa fa-gear'}></i> Zgłoszenie w realizacji</span> : null)
                                                    }

                                                </span>
                                                <span style={{marginLeft: '15px'}}>
                                                    {
                                                        (this.state.zgloszenie.status !== 1) ?
                                                            <TopButtonAction iconType={'fa fa-ban'}
                                                                             text={'Zamknij zgłoszenie'} btnSize={'md'}
                                                                             onClick={this.onClickZamknijZgloszenie}
                                                                             btnColor={'default'}/>
                                                            :
                                                            <span className={'text-danger'}
                                                                  style={{fontSize: '14px'}}><i
                                                                className={'fa fa-ban'}></i> Zgłoszenie zamknięte</span>
                                                    }

                                                </span>
                                                {
                                                    Boolean(this.state.klientJednorazowy) ?
                                                        <span style={{fontSize: '14px'}}>
                                                        <TopAlertInformacja inline={true}
                                                                            text={'Zgłoszenie wysłane przez anonimowego klienta'}/>
                                                        </span>
                                                        :
                                                        ''
                                                }
                                            </div>
                                            <div id={'zgloszenieAutor'}>
                                                {
                                                    Boolean(this.state.klient) ?
                                                        <EBOKWatekKlient klient={this.state.klient}/>
                                                        :
                                                        Boolean(this.state.klientJednorazowy) ?
                                                            <div id={'kartaKlienta'}>
                                                                <div>
                                                                    <label>Klient:</label><span
                                                                    style={{marginLeft: '5px'}}>{this.state.klientJednorazowy.imieNazwisko}</span>
                                                                </div>
                                                                <div>
                                                                    <label>Email:</label><span
                                                                    style={{marginLeft: '5px'}}>{this.state.klientJednorazowy.email}</span>
                                                                </div>
                                                            </div>
                                                            :
                                                            ''
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                    <EBOKWatekTresc zgloszenie={this.state.zgloszenie}
                                                    handleSendResponse={this.onClickDodajOdp}
                                                    czyJednorazowy={Boolean(this.state.klientJednorazowy)}/>
                                </div>

                                    {
                                        this.state.pokazModal ?
                                            <div id={'EBUSModalContainerBG'}>
                                                <div id={'modalContainer'} className={'modalFakturaDuzy'}>
                                                    <div>
                                                        <div id={'modalTextContent'}>
                                                            <div>
                                                                <div className={'pull-right'}>
                                                                    <TopButtonAction onClick={() => {
                                                                        this.setState({pokazModal: false, biletZSzukaniaPoKodzieZParagonu: null,})
                                                                    }}
                                                                                     elementStyle={{color: 'firebrick'}}
                                                                                     btnColor={'default'} text={'Zamknij'}
                                                                                     iconType={'fa fa-times'}
                                                                    />

                                                                </div>
                                                            </div>
                                                            <div style={{clear: 'both', height: '15px'}}></div>
                                                            {
                                                                this.state.setLoader ?
                                                                    <div id={'simple-small-loader'}>
                                                                        <i className={'fa fa-spinner fa-spin'}></i>
                                                                    </div>
                                                                    :
                                                                    this.state.errorModal.length > 0 ?
                                                                        <TopAlertUwaga text={this.state.errorModal}/>
                                                                        :
                                                                        <div>
                                                                            <BiletKodZParagonuContainer bilet={this.state.biletZSzukaniaPoKodzieZParagonu}
                                                                                                        zamknijModal={() => this.setState({
                                                                                                            pokazModal: false,
                                                                                                            biletZSzukaniaPoKodzieZParagonu: null
                                                                                                        })}/>
                                                                        </div>
                                                            }

                                                            <div style={{clear: 'both'}}></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            ''
                                    }

                                </div>
                                :
                                <TopAlertUwaga
                                    text={'Wystąpił problem z załadowaniem zgłoszenia bądź nie istnieje zgłoszenie o takim ID'}/>
                    }
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/eBOK/EBOKWatekContainer.js